/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PreferredDirection {
  PREFER_LOWER = 'PREFER_LOWER',
  PREFER_HIGHER = 'PREFER_HIGHER',
}
